
  $('.customily-close-button').on('click',function(e){
    e.preventDefault();
    $('.customily-modal-preview-only').removeClass('active');
  });
  
  $('.upsell_select').on('change', function(){
    const parent = $(this).parents('.upsell.cart__item');
    const url = parent.find('.cart-product-title > a').attr('href');
    const value = this.value;
    if(!url) return;
    $.ajax({
      type: 'GET',
      url: `${url}.json`,
      success(data) {
        const variants = data.product.variants;
        const variant = variants && variants.find(item => item.id == value);
        if(variant.price < variant.compare_at_price){
          const price = window.Shopify.formatMoney(variant.price, $('body').data('money-format'));
          const compare_at_price = window.Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format'));
          parent.find('.modal_price').html(`<span class="money was_price">${compare_at_price}</span> <span class="money">${price}</span>`);
        }else {
          const price = window.Shopify.formatMoney(variant.price, $('body').data('money-format'));
          parent.find('.modal_price').html(`<span class="money">${price}</span>`)
        }
      },
      error(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
      }
    })
  });
  
  let cartRecommendProducts = function(){
    if(!$('.cart-product-list-related')) return;
    let limit = 10;
    let getRecommendProducts = async function(){
      let rPush = [];
      let values = $("#static-cart-recommend").val();
      if(!values) return;
      let arrayRecommendItems = values && values.split(',');
  
      arrayRecommendItems.forEach(async (i)=>{
        let recommendUrl = `/recommendations/products?section_id=product-recommendations&limit=10&product_id=${i}`;
        rPush.push(new Promise( (rv, rs)=>{
          fetch(recommendUrl)
            .then(response => response.text())
            .then(e => {
              if('undefined' == typeof e){
                rv('');
              }
              else{
                rv(e);
              }
            })
        }))
      })
      return await Promise.all(rPush)
    }
    
    let ie = getRecommendProducts();
    ie.then(e =>{
      let html = '';
      e?.map(i=>html += i);
      let parser = new DOMParser();
      html = parser.parseFromString(html, "text/html");
  
      var productItems = [...html.querySelectorAll('[data-product-item]')];
      let productExist = [];
      if (productItems.length) {
        document.querySelector(".cart-product-list-related").style.display = "block"
        productItems.sort(()=> Math.random() - 0.5);
        let i=0;
        productItems.forEach(function (productItem) {
          let quickHandle = productItem.dataset.productHandle;
          if(!productExist.includes(quickHandle) && i < limit){
            productItem.classList.remove("visible-3");
            productItem.classList.add("visible-5");
            productExist.push(quickHandle);
            document.querySelector('#product-list-related').insertAdjacentHTML('beforeend', productItem.outerHTML);
            i++;
          }
        });
        if(productItems.length > 5){
          var flkty = new Flickity("#product-list-related", {
            // options
            cellAlign: 'left',
            contain: true,
            groupCells: true,
            freeScroll: true,
            wrapAround: true,
            draggable: true
          });
        } else{
          document.querySelector("#product-list-related").style.display = "flex";;
        }
      }
    });
  }
  
  const getImagePreview = function(){
    const allCartItemImages = document.querySelectorAll(".cart_page_image_wrap");
    if(allCartItemImages.length == 0 ){return}
    
    allCartItemImages.forEach((element) => {
      var listenerPaste = element.hasOwnProperty("isEvent");
      if (!listenerPaste) {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          const key = element.getAttribute("data-key");
          handleOpenModalClick(key);
        });
        element.isEvent = true;
      }
    });
    
    document.querySelector(".icon-closed").addEventListener('click', function(event) {
      event.preventDefault();
      handleCloseModal();
    });
  
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('modal--active')) {
        event.preventDefault();
        handleCloseModal();
      }
    });
  }
  
  function handleOpenModalClick(imgKey) {
    const modalImg = document.querySelector(".wrapper-modal-preview .preview-img-modal .so-featured-image");
    try{
      modalImg.style.display = "none";
    
      const imgEl = document.querySelector(`.cart_page_image_wrap[data-key="${imgKey}"] img`);
    
      const imageItem = tfxCart.items.find((item) => item.key === imgKey);
      var imgSrc = imageItem?.properties["_customily-preview"];
      const thumId = imageItem?.properties["_customily-thumb-id"];
      if (!imgSrc && imgEl?.preview) {
        imgSrc = imgEl.preview?.src;
      } else if (!imgSrc) {
        imgSrc = imgEl?.dataset?.backupSrc || imgEl?.getAttribute("preview-src");
      }
    
      var id = thumId.split("_thumb-id-")[1];
      var data = localStorage.getItem("customily-shopify-thumbs-" + id);
      if (data && Date.now() - JSON.parse(data).timestamp < 2592e6 && modalImg.dataset.key != imgKey) {
        imgSrc += "?" + new Date().getTime();
        modalImg.addEventListener("load", function () {
          modalImg.dataset.key = imgKey;
        });
        modalImg.addEventListener("error", function () {
          modalImg.onerror = null;
          setTimeout(function () {
            modalImg.src = imgEl.src;
          }, 500);
        });
        modalImg.src = imgSrc;
      } else {
        imgSrc += "?" + new Date().getTime();
        modalImg.src = imgSrc;
      }
    
      const modalItem = document.querySelector(".wrapper-modal-preview");
      modalItem.classList.toggle("modal--active");
      modalImg.style.display = "block";
    } catch(e) {
      console.log(e);
    }
  };
  
  function handleCloseModal() {
    const modalImg = document.querySelector(
      ".wrapper-modal-preview .preview-img-modal .so-featured-image"
    );
    const modalItem = document.querySelector(".wrapper-modal-preview");
    modalItem.classList.remove("modal--active");
    modalImg.src = "https://cdn.shopify.com/s/files/1/0529/6927/5569/files/loading_bg.gif?v=1698200196";
  };
  
  document.querySelector(".overlay-modal-preview")?.addEventListener("click", (e) => {
    e.preventDefault();
    handleCloseModal();
  });
getImagePreview();
cartRecommendProducts();